import { Store } from 'game/store/gameStore';
import { GAEvent, GAEventNames } from './events';

export function logWinGame(autocomplete: 'auto' | 'clicked' | 'no') {
    const data = {
        id: Store.gameId,
        type: Store.getGameTypeText(),
        difficulty: Store.getDifficultyText(),
        moves: Store.movesCount,
        score: Store.score,
        timeSec: Store.time,
        timeMin: Store.timeMin,
        undos: Store.undos,
        hint: Store.hints,
        deckTurns: Store.deckTurns,
        attempts: Store.attempts,
        autocomplete: autocomplete,
        magic_wand: Store.magicWandUsed,
        magic_wand_used: Store.magicWandUsed ? 1 : 0,
    } as {
        id: string;
        type: string;
        difficulty: string;
        moves: number;
        score: number;
        timeSec: number;
        timeMin: number;
        undos: number;
        hint: number;
        deckTurns: number;
        attempts: number;
        autocomplete: 'auto' | 'clicked' | 'no';
        autoPlay: 'On' | 'Off';
        magic_wand: number;
        magic_wand_used: 0 | 1;
    };
    if (Store.isKlondike || Store.isFreecell) data.autoPlay = Store.autoPlay ? 'On' : 'Off';

    GAEvent(GAEventNames.GAME_WIN, data);

    const winLogs = [
        3, 5, 7, 10, 15, 20, 25, 30, 50, 100, 150, 200, 250, 300, 500, 1000, 1500, 2000, 3000, 4000, 5000, 10000, 20000,
        50000,
    ];
    const totalWins = Store.gameWins[Store.name];
    if (winLogs.includes(totalWins)) {
        GAEvent(`game_win_${totalWins}`, {});
    }
    if (totalWins === 3) {
        try {
            window.uetq = window.uetq || [];
            window.uetq.push('event', 'game_win_3', {});
        } catch (error) {}
    }
}
